// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_dz-0";
export var fileCarousel = "_dz-2";
export var removeFileButton = "_dz-1";